export default __webpack_public_path__ + "static/top-e8b8d562b70f7ab0d3faa510f66f034d.jpg";